import React from 'react';
import PropTypes from 'prop-types';

import LabeledSelectBox from 'components/consumer/LabeledSelectBox';

const PDPUpholsterySortBy = ({ selectedOption, setSelectedOption }) => (
  <LabeledSelectBox
    label="Sort by"
    onChange={event => {
      setSelectedOption(event?.target?.value);
    }}
    options={[
      {
        value: 'family',
        label: 'Family',
      },
      {
        value: 'popularity',
        label: 'Popularity',
      },
      {
        value: 'tier',
        label: 'Tier',
      },
    ]}
    showSingleLineLabelOverlay
    prefixOptionsWithLabel
    showBlankOption={false}
    size="sm"
    value={selectedOption}
  />
);

PDPUpholsterySortBy.propTypes = {
  selectedOption: PropTypes.string,
  setSelectedOption: PropTypes.func,
};

export default PDPUpholsterySortBy;
